export default class User {
    id: number;
    roles: string[];
    systemDate: string;

    constructor(data: any) {
        this.id = data.id;
        this.roles = data.roles || [];
        this.systemDate = data.systemDate;
    }

    public isInRole(role: string): boolean {
        return this.roles.some(r => r.toLowerCase() === role.toLowerCase());
    }
}
